exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#paypal_button_container[data-v-97ab1636]{margin-bottom:14px}", ""]);

// exports
